import { Play } from "../api/types";
import { getFieldDataUri, buildFieldLayer } from "./fields";
import { buildShapesLayer } from "./shapes";
import { buildLinesLayer } from "./lines";
import { buildTextLayer } from "./text";
import { buildPencilLayer } from "./pencil";
import { FONT_FACE_CSS } from "./fonts";
import { normalizePlay } from "./normalize";

export interface PlaySvgResult {
  svg: string;
  fieldDataUri: string | null;
  width: number;
  height: number;
}

// Field images are 5005×4000 (middle/endZone) or 5005×10970 (full).
// The play coordinate system is 1200 units wide.
const DEFAULT_DIMS: Record<string, { width: number; height: number }> = {
  middle:  { width: 1200, height: 959 },
  endZone: { width: 1200, height: 959 },
  full:    { width: 1200, height: 2630 },
};

export async function playToSvg(play: Play): Promise<PlaySvgResult> {
  const normalizedPlay = normalizePlay(play);
  const fallback = DEFAULT_DIMS[normalizedPlay.zone] ?? DEFAULT_DIMS.middle;
  const width = normalizedPlay.width || fallback.width;
  const height = normalizedPlay.height || fallback.height;
  const renderPlay = { ...normalizedPlay, width, height };

  const [fieldDataUri, shapesResult] = await Promise.all([
    getFieldDataUri(renderPlay),
    Promise.resolve(buildShapesLayer(renderPlay)),
  ]);

  const fieldLayer = buildFieldLayer(renderPlay, fieldDataUri);
  const linesLayer = buildLinesLayer(renderPlay);
  const textLayer = buildTextLayer(renderPlay);
  const pencilLayer = buildPencilLayer(renderPlay);

  const gradientDefs = shapesResult.defs || "";

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 ${width} ${height}" width="${width}" height="${height}">
  <defs>
    <style>${FONT_FACE_CSS}</style>
    ${gradientDefs}
  </defs>
  ${fieldLayer}
  ${linesLayer}
  ${shapesResult.element}
  ${textLayer}
  ${pencilLayer}
</svg>`;

  return { svg, fieldDataUri, width, height };
}
